import { Link } from 'react-router-dom';
import './reset-password.scss';

const ResetPassword = () => {
    const handleBackLanding = () => {
        window.open('https://rpp.pe/empresasquetransforman', '_self');
    };

    return (
        <div className="ResetPasswordWrapFull">
            <div className="ResetPasswordLogo">
                <img
                    alt="Empresas que transforman el Perú"
                    src="/images/logo.png"
                    onClick={handleBackLanding}
                />
            </div>
            <div className="ResetPasswordWrap">
                <div className="ResetPasswordWrapInner">
                    <h4 className="ResetPasswordTitle">
                        Tu contraseña ha sido restablecida
                    </h4>
                    <p className="mb2">
                        Ahora podrás acceder nuevamente a<br></br> Empresas que
                        Transforman el Perú
                    </p>
                    <Link className="button buttonAuto" to="/signin">
                        Aceptar
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ResetPassword;
